import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Program } from '../../Models/Program';
import { GetPrograms } from '../../Services/ProgramService';
import './SendPushNotification.css';
import UnauthorizedPage from './Children/UnauthorizedPage/UnauthorizedPage';
import SendPushNotificationForm from './Children/SendPushNotificationForm/SendPushNotificationForm';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';

export default function SendPushNotification() {
    const [programs, setPrograms] = useState<Program[]>([]);
    const [showLoadingSpinner, setShowLoadingSpinner] = useState(true);
    const [unauthorized, setUnauthorized] = useState<boolean>(false);
    const { instance, inProgress, accounts } = useMsal();

    useEffect(() => {
        const tokenRequest = {
            scopes: [""],
            account: accounts[0],
        };
        if (programs.length === 0 && inProgress === InteractionStatus.None) {
            instance
                .acquireTokenSilent(tokenRequest)
                .then((response) => {
                    GetPrograms(response.idToken)
                        .then((response) => {
                            setPrograms(response.data.programs);
                        }).then(() => {
                            setShowLoadingSpinner(false);
                        }).catch((error) => {
                            if (error.response.status === 403) {
                                setUnauthorized(true);
                                setShowLoadingSpinner(false);
                            }
                        });
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(tokenRequest);
                    }
                });
        }
    }, [instance, accounts, inProgress, programs]);

    return (
        <>
            {showLoadingSpinner ?
                <div className="center">
                    <CircularProgress />
                </div>
                :
                <>
                    {unauthorized ?
                        <UnauthorizedPage />
                        :
                        <SendPushNotificationForm programs={programs} />
                    }
                </>
            }
        </>
    )
};